import React, { useEffect } from "react";

interface SnackbarProps {
  message?: string;
  open: boolean;
  onClose: () => void;
  severity: "error" | "success" | "info" | "warning" | string;
}

const Snackbar: React.FC<SnackbarProps> = ({
  message,
  open,
  onClose,
  severity,
}) => {
  const getBackgroundColor = () => {
    switch (severity) {
      case "error":
        return "#f8d7da"; // Red for error
      case "success":
        return "#d1e7dd"; // Green for success
      case "info":
        return "cfe2ff"; // Blue for info
      case "warning":
        return "#fff3cd"; // Orange for warning
      default:
        return "#333";
    }
  };

  const textColor = () => {
    switch (severity) {
      case "error":
        return "#842029"; // Red for error
      case "success":
        return "#0f5132"; // Green for success
      case "info":
        return "#084298"; // Blue for info
      case "warning":
        return "#664d03"; // Orange for warning
      default:
        return "#333";
    }
  };

  const btnbg = () => {
    switch (severity) {
      case "error":
        return "#c55f68"; // Red for error
      case "success":
        return "#24a566"; // Green for success
      case "info":
        return "#084298"; // Blue for info
      case "warning":
        return "#664d03"; // Orange for warning
      default:
        return "#333";
    }
  };

  const textBorder = () => {
    switch (severity) {
      case "error":
        return "#842029"; // Red for error
      case "success":
        return "#0f5132"; // Green for success
      case "info":
        return "#084298"; // Blue for info
      case "warning":
        return "#664d03"; // Orange for warning
      default:
        return "#333";
    }
  };

  // const getMessageHeading = () => {
  //   switch (severity) {
  //     case 'error':
  //       return 'Action Failed';
  //     case 'success':
  //       return 'Success !';
  //     case 'info':
  //       return 'Information';
  //     case 'warning':
  //       return 'Warning!';
  //     default:
  //       return 'Notification';
  //   }
  // };

  // Automatically close the Snackbar after 4 seconds
  useEffect(() => {
    if (open) {
      const delay = severity === "success" ? 800 : 3000;
      const timer = setTimeout(onClose, delay);
      return () => clearTimeout(timer); // Cleanup timeout on unmount or when `open` changes
    }
  }, [open, onClose]);

  return (
    <div
      id="snackbarComp"
      className={`snackbar ${open ? "show" : "hide"}`}
      style={{
        position: "fixed",
        display: open ? "block" : "none",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: getBackgroundColor(),
        color: textColor(),
        padding: "10px 18px",
        borderRadius: "5px",
        zIndex: 9999,
        opacity: open ? 1 : 0,
        transition: "opacity 0.3s ease",
        maxWidth: "400px",
        minWidth: "300px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
      }}
    >
      {/* <h2>{getMessageHeading()}</h2> */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: getBackgroundColor(),
          padding: " 2px 0px",
        }}
      >
        <button
          style={{
            background: getBackgroundColor(),
            borderColor: textBorder(),
            color: textColor(),
            fontSize: "20px",
            cursor: "pointer",
            height: "22px",
            width: "22px",
            lineHeight: "16px",
            borderRadius: "50%",
            border: "0px solid",
          }}
          onClick={onClose}
        >
          &times;
        </button>
      </div>
      <div>
        <ul className="slim-scroll">
          {(message ?? "").split("\n").map((msg, index) => (
            <li key={index}>{msg}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Snackbar;
